define.alias("ember-power-select/helpers/ember-power-select-is-group", "preview-grid/helpers/ember-power-select-is-group");